module.exports = __webpack_public_path__ + "static/media/icon_171.fc2ca2ff.svg";